module.exports = __webpack_public_path__ + "static/media/boat-img-15.9a459a47.jpg";